module.exports = __webpack_public_path__ + "img/invoice-de-male-wm-rp.0312e1a2.png";